// @flow
import styled from 'styled-components';

export const PickerContainer = styled.div`
    height: 90%;
    margin: 5%;
    width: 90%;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/schedule-type/warm-white-light/style.js